import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App.jsx';
import TermsPage from './TermsPage';
import SchoolsFaqPage from './SchoolsFaqPage';
import PrivacyPage from './PrivacyPage';
import RespondPage from './RespondPage';

// /respond/<token> — a school answering a booking request from its email.
const respondToken = (window.location.pathname.match(/^\/respond\/([a-f0-9]{32,128})\/?$/) || [])[1];

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/^\/terms\/?$/.test(window.location.pathname) ? <TermsPage />
      : /^\/help\/schools\/?$/.test(window.location.pathname) ? <SchoolsFaqPage />
      : /^\/privacy\/?$/.test(window.location.pathname) ? <PrivacyPage />
      : respondToken ? <RespondPage token={respondToken} />
      : <App />}
  </React.StrictMode>
);
